// ABOUTME: Pure helpers for validating shipping address fields.
// ABOUTME: Determines which countries require a house number and whether a street line contains one.

import { countryCodeNL, countryCodeBE, countryCodeDE } from './constants';

// Countries where the street line (address1) must include a house number.
const houseNumberRequiredCountries = [countryCodeNL, countryCodeBE, countryCodeDE];

/**
 * Returns true when the given country code requires a house number in the street line.
 * Country codes are alpha2 lowercase (e.g. "nl", "be", "de").
 */
export const countryRequiresHouseNumber = (countryCode) => {
    if (!countryCode) return false;
    return houseNumberRequiredCountries.includes(String(countryCode).toLowerCase());
};

/**
 * Returns true when the street line contains a house number.
 * A house number is detected as any digit in the line (e.g. "Main street 12").
 */
export const addressHasHouseNumber = (addressLine) => {
    if (!addressLine) return false;
    return /\d/.test(String(addressLine));
};
